import React, { useState } from 'react';
import authService, { AuthenticationResultStatus } from "../../services/AuthService";
import { QueryParameterNames } from "../../components/auth/Auth.model";
import { FiEye, FiEyeOff } from 'react-icons/fi';
import RectangularClockWrapper from '../../components/shared/ClockLogo/ClockLogo';
import logo from '../../assets/logo_blue.svg';
import gear from '../../assets/gear.svg';

const Login = (props) => {
  const [message, setMessage] = useState("");
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleUserNameChange = (event) => {
    setLogin(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");

    const returnUrl = getReturnUrl();
    const state = { returnUrl };
    const result = await authService.signIn(state, login, password);

    switch (result.status) {
      case AuthenticationResultStatus.Redirect:
        break;
      case AuthenticationResultStatus.Success:
        window.location.replace(returnUrl);
        break;
      case AuthenticationResultStatus.Fail:
        setMessage('Неправильный логин или пароль');
        break;
      default:
        throw new Error(`Invalid status result ${result.status}.`);
    }
  };

  const getReturnUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get(QueryParameterNames.ReturnUrl);
    if (fromQuery && !fromQuery.startsWith(`${window.location.origin}/`)) {
      throw new Error("Invalid return url. The return url needs to have the same origin as the current page.")
    }
    return fromQuery || `${window.location.origin}/devices`;
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh'}}>
      <RectangularClockWrapper style={{ position: 'relative', overflow: 'visible' }}>
        <img src={gear} alt="gear1" className="gear gear1" />
        <img src={gear} alt="gear2" className="gear gear2" />
        <img src={gear} alt="gear3" className="gear gear3" />

        <div className="auth-card card p-4 border-0 d-flex justify-content-center align-items-center" style={{
          width: '100%',
          maxWidth: '300px',
          maxHeight: '440px',
          zIndex: 1,
          position: 'relative',
        }}>

          <img src={logo} alt="BigClock Logo" className="logo mb-2" style={{ width:'150px', height: '80px' }} />
          <span className='logo_span mb-5 mt-4' style={{ fontSize: '20px'}}>Центр управления часами</span>

          {message && (
            <div className="alert alert-danger" role="alert">
              {message}
            </div>
          )}

          <form className='mt-4' onSubmit={handleSubmit} style={{width: '100%', maxWidth: '300px'}}>
            <div className="mb-3">
              <input
                type="text"
                name="username"
                id="inputLogin"
                autoComplete="username"
                className="form-control"
                placeholder="Логин"
                style={{
                  border: 'none',
                  borderBottom: '1px solid #ccc',
                  borderRadius: 0
                }}
                value={login}
                onChange={handleUserNameChange}
              />
            </div>

            <div className="mb-4">
              <div className="input-group">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  id="inputPassword"
                  autoComplete="current-password"
                  className="form-control"
                  placeholder="Пароль"
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #ccc',
                    borderRadius: 0
                  }}
                  value={password}
                  onChange={handlePasswordChange}
                />
                <span
                  className="input-group-text"
                  style={{
                    background: '#fff',
                    cursor: 'pointer',
                    border: 'none',
                    borderBottom: '1px solid #ccc',
                    borderRadius: 0
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEye className="icon-gray" /> : <FiEyeOff className="icon-gray" />}
                </span>
              </div>
            </div>

            <div className="d-grid gap-2 mt-5">
              <button
                type="submit"
                className={`btn ${login && password ? 'btn-blue' : 'btn-secondary'}`}
                disabled={!login || !password}
              >
                Войти
              </button>
            </div>
          </form>
        </div>
      </RectangularClockWrapper>
    </div>
  );
};

export default Login;
